export interface IForm {
    usuario: string;
    currentPassword: string,
    newPassword: string;
    repeatPassword: string;
}

export const initIForm: IForm = {
    usuario: '',
    currentPassword: '',
    newPassword: '',
    repeatPassword: '',
}